












import { Vue, Component } from 'vue-property-decorator';
import { Emit, Prop } from '@samclick-commons';

    @Component
export default class SamclickDatePicker extends Vue {
        @Prop({ default: '' }) private value!: string;

        @Emit('focus')
        focus(e:any) {
          return e || '';
        }

        @Emit('input')
        input(e:any) {
          return e;
        }

        @Emit('change')
        change(e:any) {
          return e;
        }

        @Emit('blur')
        blur(e:any) {
          return e;
        }

        get generatedValue() {
          if (this.$props.value) {
            return new Date(this.$props.value);
          }

          return '';
        }

        get defaultAttrs() {
          const defaultAttr = {
            size: 'small',
            type: 'date',
            placeholder: 'YYYY-MM-DD',
            class: 'full-width',
            'value-format': 'yyyy-MM-dd[T]HH:mm:ss.SSS[Z]',
          };


          return defaultAttr;
        }

        get overrideAttrs() {
          return Object.assign(this.defaultAttrs, this.$attrs);
        }
}
